import { withParams } from 'vuelidate';
export default (equalTo) =>
	withParams({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
		return value != parentVm[equalTo];
	});
